import { ActionTypesUser } from "../constants/action-types";
import { axios, socket  } from "../../utils"
import { useDispatch , useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import store from '../store'

const userSignInRequest =(signInData,params)=>{
    return {
        type:ActionTypesUser.USER_SIGN_IN_REQUEST,
        payload:{
            signInData:signInData,
            params:params,
        }
    }
}

const userSignInError =(err)=>{
    return {
        type:ActionTypesUser.USER_SIGN_IN_ERROR,
        payload:{
            error:err
        }
    }
}

const userSignInSuccess = (userData)=>{
    userData = { ...userData, "providerSenderId":uuidv4(),"providerDialogId":uuidv4()}
    return {
        type:ActionTypesUser.USER_SIGN_IN_SUCCESS,
        payload:{
            user:userData
        }
    }
}

const userSignOutRequest =()=>{
    return {
        type:ActionTypesUser.USER_SIGN_OUT_REQUEST
    }
}

const userSignOutError =(err)=>{
    return {
        type:ActionTypesUser.USER_SIGN_OUT_ERROR,
        payload:{
            error:err
        }
    }
}

const userSignOutSuccess = ()=>{
    return {
        type:ActionTypesUser.USER_SIGN_OUT_SUCCESS
    }
}


export const signIn = (reqPayload,engagementParams)=>{
    const {user , ui } = store.getState();
    console.log(reqPayload);
    return async (dispatch,getState)=>{
        dispatch(userSignInRequest(reqPayload,engagementParams))
        
        try{
            // let { data } = await axios.post(`${getState().ui.config.connectorUrl}/createSession`,reqPayload)
            let { data } = await axios.post(`${process.env.REACT_APP_CHATCON_URL}/createSession`, reqPayload);

            dispatch(userSignInSuccess(data))
        }catch(e){
            dispatch(userSignInError(e))
        }
    }
} 
/*
//re-visit
export const startAnewSession = ()=>{
    return async (dispatch,getState)=>{
        const { user, engagement } = getState();
        const engagementParamters = engagement.params;
        // await dispatch(resetEngagement()) 
        await dispatch(setEngagementParameters(engagementParamters))
        //@ts-ignore
        await dispatch(signIn(user.signIn.data,getState().user?.signIn?.params, engagementParamters))

        //await dispatch(createEngagement({sessionId:user?.data?.sessionId}))       
    }
}

export const signOut = ()=>{
    return async (dispatch , getState)=>{
        let { user } = getState()
        dispatch(userSignOutRequest())
        await dispatch(terminateEngagement())
            try{
                await axios.post(`${getState().ui.config.connectorUrl}/terminateSession`,{sessionId:user.data.sessionId})
                dispatch(userSignOutSuccess())
            }catch(e){
                dispatch(userSignOutError(e))
            }
    }
}
*/
